var StatusView = Backbone.View.extend({
    el: '.statusContainer',
    initialize: function (options) {
        this.statusMessage = $('#statusMessage');
        
        this.model.connections.bind('init', this.loadingStep, this);
        this.model.bind('doneLoading', this.clearMessage, this);
        
        this.model.backend.bind('stream:starting', this.connecting, this);
        this.model.backend.bind('stream:stopped', this.stopped, this);
        this.model.backend.bind('connected', this.loading, this);
        this.model.backend.bind('tempUnavailableTick', this.tempUnavailableTick, this);
        this.model.backend.bind('unsupported', this.clearMessage, this);
        this.model.backend.bind('offline', this.stopped, this);
        
        this.renderVisible();
    },
    events: {
        'click #statusMessage a.reconnect': 'clickReconnect'
    },
    clickReconnect: function (e) {
        e.preventDefault();
        this.model.startBackend();
    },
    loading: function (numConnections) {
        this.clearReconnectingCountdown();
        this.setMessage('Loading…');
    },
    loadingStep: function (connection) {
        if (!this.model.isInitialized()) {
            this.setMessage('Loading… (' + connection.getName() + ')');
        }
    },
    renderVisible: function () {
        var contents = this.statusMessage.html();
        this.statusMessage.toggle(!!contents);
        this.$el.toggle(!!contents || this.model.isXhrFallback() || this.model.isDbDown());
        this.trigger('change');
    },
    setMessage: function (text) {
        this.statusMessage.text(text);
        this.renderVisible();
    },
    setMessageHtml: function (html) {
        this.statusMessage.html(html);
        this.renderVisible();
    },
    clearMessage: function () {
        this.setMessage('');
    },
    reconnectingIn: function (seconds) {
        this.setMessage('Reconnecting in ' + seconds + ' second' + (seconds == 1 ? '' : 's') + '…');
        this.reconnectingCountdown(seconds - 1);
    },
    clearReconnectingCountdown: function () {
        if (this.connectingMessageTimeout) {
            clearTimeout(this.connectingMessageTimeout);
            this.connectingMessageTimeout = null;
        }
    },
    reconnectingCountdown: function (seconds) {
        this.connectingMessageTimeout = setTimeout(_.bind(function () {
            if (seconds) {
                this.reconnectingIn(seconds);
            } else {
                this.setMessage('Reconnecting…');
            }
        }, this), 1000);
    },
    connecting: function () {
        if (this.model.backend.startDelay) {
            this.clearReconnectingCountdown();
            this.reconnectingIn(this.model.backend.startDelay);
        } else {
            this.setMessage('Connecting…');
        }
    },
    stopped: function () {
        this.clearReconnectingCountdown();
        
        if (this.model.isAuthed()) {
            this.setMessageHtml('Offline. <a href="" class="reconnect">Reconnect</a>');
        } else {
            this.clearMessage();
        }
    },
    tempUnavailableTick: function (seconds) {
        var msg = 'Your account is temporarily unavailable (retrying in ' + seconds + ' second' + (seconds == 1 ? '' : 's') + ')<br><a href="" class="reconnect">Reconnect now</a>';
        if (!this.model.ent()) {
            msg += ' • Check <a href="https://bsky.app/profile/irccloud.com" target="_blank" rel="noreferrer">Bluesky</a> for updates';
        }
        this.setMessageHtml(msg);
        this.trigger('change');
    }
});


module.exports = StatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/statusview.js
// module id = 4lyz
// module chunks = 1